import React, { useState, useRef, useEffect } from 'react';
import { Route, Routes, useLocation, useSearchParams } from "react-router-dom";
import { config } from "./shared/config";
import * as util from './shared/commons';
import axios from "axios";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Sidebar } from 'primereact/sidebar';        
import { Sidebar as ProSideBar } from 'react-pro-sidebar';
import { Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Button } from 'primereact/button';
import ProductSelector from './contracts/ProductSelector';
import Login from './user/Login';
import ResetPassword from './user/ResetPassword';
import RequestMembership from './user/RequestMembership';
import GetCompanyDetailInContractRequest from './contracts/GetCompanyDetailInContractRequest';
import CheckUserExistance from './user/CheckUserExistance';
import ShowBuyProductSummary from './contracts/ShowBuyProductSummary';
import SelectIpg from './payment/SelectIpg';
import ShowMyContracts from './contracts/ShowMyContracts';
import ZarinpalVerifyPayment from './payment/ZarinpalVerifyPayment';
import ShowMyWallet from './payment/ShowMyWallet';
import ContractList from './admin/contracts/ContractList';
import UserList from './admin/users/UserList';
import ChangePassword from './admin/users/ChangePassword';
import DiscountList from './admin/discount/DiscountList';
import ProductList from './admin/product/ProductList';
import PromoteContractMudules from './contracts/PromoteContractMudules';
import PromoteContractParameters from './contracts/PromoteContractParameters';
import BillDescriptions from './admin/setting/BillDescriptions';
import Chat from './chat/Chat';
import ShowMyWalletTransactions from './payment/ShowMyWalletTransactions';
import Logout from './user/Logout';
import WinAccountingParams from './admin/setting/WinAccountingParams';
import SchoolAccountingParams from './admin/setting/SchoolAccountingParams';
import SandooghParams from './admin/setting/SandooghParams';
import TaxServiceParams from './admin/setting/TaxServiceParams';
import SoftwareLogin from './user/SoftwareLogin';
import DownloadFile from './files/DownloadFile';
import StartBuyFromOtherSystem from './contracts/StartBuyFromOtherSystem';
import ShowPaymentResult from './payment/ShowPaymentResult';
import ServiceList from './admin/product/ServiceList';
import BuyService from './contracts/BuyService';
import ShowMyBuyServices from './contracts/ShowMyBuyServices';
import BuyServiceList from './admin/contracts/BuyServiceList';
import IpgTransactionList from './admin/contracts/IpgTransactionList';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [redirectUrl, setRedirectUrl] = useState("");
  const ref = useRef();
  const [searchParams] = useSearchParams();
  const [accountChanged, setAccountChanged] = useState(0);
  const [sideBarVisible, setSideBarVisible] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  

  useEffect(() => {

    const checkLogin = () => {
      console.log("login checked")
      var b = util.isLogedInServer(setAsLoggedIn, setAsNotLoggedIn);
      if(b){
        util.setCurrentUser(util.getCurrentUser());
      }
    };
    if((!location.pathname.includes("logout"))&&(!location.pathname.includes("software/login")))
      checkLogin();
  }, [location]);
  const setAsLoggedIn = function(){
    setIsLoggedIn(true);
  }
  const setAsNotLoggedIn = function(){
    util.clearCurrentUser();
    setIsLoggedIn(false);
  }

  const logout = function (){
    navigate("/logout");
    //util.clearCurrentUser();
    //setIsLoggedIn(false);
  }
  const topToolbar = function(){
    var user = util.getCurrentUser();
    //if(user == null)setIsLoggedIn(false);
    var buy = util.getBuy();
    var text = "پرتال مشتریان هانا";
    return(
      <div style={{position:"fixed", width:"100%", height:"70px", backgroundColor:"#C00000", color:"#FFF", top:"0px", left:"0px", zIndex:"100"}}>
        <div onClick={()=>setSideBarVisible(true)} style={{position:"absolute", top:"17px", right:"17px", width:"35px", height:"35px", cursor:"pointer"}}>
          <i className="pi pi-align-justify" style={{ fontSize: '2.5rem' }}></i>
        </div>
        <div style={{position:"absolute", top:"15px", right:"63px", width:"35px", height:"35px", cursor:"pointer"}}>
          <i className="pi pi-home" style={{ fontSize: '2.5rem' }}></i>
        </div>
        <div style={{position:"absolute", top:"17px", right:"110px", width:"calc(100% - 115px)", height:"35px", fontSize: '1.5rem'}}>
          {text}
        </div>
        <div style={{position:"absolute", top:"14px", left:"14px", width:"28px", height:"28px", cursor:"pointer"}}>
          {
            (isLoggedIn && (user != null))?
            <i onClick={()=>logout()} className="pi pi-power-off" style={{ fontSize: '2rem' }}></i>
            :
            <i onClick={()=>navigate("/login")} className="pi pi-user" style={{ fontSize: '2rem' }}></i>
          }          
        </div>
        {
          (isLoggedIn && (user != null))?
          <div style={{position:"absolute", bottom:"5px", left:"14px", width:"150px", height:"20px", textAlign:"left", fontSize: '.8rem'}}>
              {user.firstname + " " + user.lastname}
          </div>
          :
          <></>
        } 
        {
          // buy != null?
          // <div style={{position:"absolute", top:"14px", left:"65px", width:"28px", height:"28px", cursor:"pointer"}}>
          //   <i className="pi pi-shopping-cart" style={{ fontSize: '2rem' }}></i>
          //   <i className="pi pi-asterisk" style={{ fontSize: '1rem', position:"absolute", top:"-5px", left:"20px", color:"#FF0"}}></i>          
          // </div>
          // :
          // <></>

        }         
      </div>
    )
  }
  const customHeader = function () {
    var user = util.getCurrentUser();
    var mnu = "منو";
    var flname = "";
    if(user != null){
      if (user.role.id.id == util.UserRoles.Admin) mnu = "ادمین سیستم";
      else if (user.role.id == util.UserRoles.Assistant) mnu = "دستیار ادمین";
      else if (user.role.id == util.UserRoles.Agent) mnu = "نماینده فروش";
      else if (user.role.id == util.UserRoles.Client) mnu = "مشتری";
      flname = user.firstname + " " + user.lastname;
    }
    return (
      <div className="flex align-items-center gap-2">
        <span className="font-bold">{mnu}</span>
        <br />
        {flname}
      </div>
    );
  }
  const showMenus = function () {
    var user = util.getCurrentUser();
    if(user == null){
      return (        
          <Menu>
            <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/buy-product" />}> خرید محصول </MenuItem>
            <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/buy-service" />}> خرید خدمات </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/login" />}> ورود به پرتال </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/request-membership" />}> ثبت نام </MenuItem>
          </Menu>
      );
    }
    else if ((user.role.id === util.UserRoles.Admin)||(user.role.id === util.UserRoles.Assistant)) {
      return (        
          <Menu>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/admin/contract/list" />}> قراردادها </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/admin/ipg-transactions/list" />}> خریدهای اینترنتی </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/admin/buy-service/list" />}> درخواست های خدمات </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/admin/client/list" />}> کاربران </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/admin/discount-token/list" />}> کد های تخفیف </MenuItem>
            <SubMenu label="جداول پایه و تنظیمات">
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/admin/product/list" />}> محصولات </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/admin/service/list" />}> خدمات </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/basic/paremeter/bill-descriptions" />}> متن های ثابت صورتحساب </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/basic/paremeter/win-accounting" />}> پارامترهای حسابداری ویندوزی </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/basic/paremeter/school-accounting" />}> پارامترهای مدیریت مدرسه </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/basic/paremeter/sandoogh" />}> پارامترهای صندوق وام </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/basic/paremeter/tax-service" />}> پارامترهای سامانه مالیاتی </MenuItem>
            </SubMenu>
            
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/user/change-password" />}> تغیر کلمه عبور </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/chat" />}> گقتگو </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); util.clearCurrentUser(); }} component={<Link to="/logout" />}> خروج </MenuItem>
          </Menu>
      );
    }
    else if (user.role.id === util.UserRoles.Client) {
      return (        
          <Menu>
            <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/my-contracts/list" />}> فرارداد های من </MenuItem>
            <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/my-services/list" />}> خدمات من </MenuItem>
            <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/my-wallet/get" />}> کیف پول </MenuItem>
            <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/buy-product" />}> خرید محصول </MenuItem>
            <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/buy-service" />}> خرید خدمات </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/user/change-password" />}> تغیر کلمه عبور </MenuItem>
            <MenuItem onClick={() => { setSideBarVisible(false); setAsNotLoggedIn(); util.clearCurrentUser(); }} component={<Link to="/log-out" />}> خروج </MenuItem>
          </Menu>
      );
    }
  }
  const createRightSidebar = function(){

    return(
      <>
      <div className="card">
      <Sidebar visible={sideBarVisible} header={customHeader} position="left" onHide={() => setSideBarVisible(false)}>
        <ProSideBar>
          {showMenus()}
        </ProSideBar>
      </Sidebar>
      </div>
      </>
    )
  }
  
  return (
    <>
    {topToolbar()}
    {createRightSidebar()}
    <Container fluid style={{marginTop:"70px", zIndex:"1", minHeight:"calc(100vh - 450px)", position:"relative"}}>
      <Row style={{margin:"0px", padding:"0px"}}>
      {
      isLoggedIn ?
      <>
      <> 
        <Routes>
          <Route path="/logout" Component={() => (<Logout onLoggedOut={() => { setAsNotLoggedIn() }} />)} />
          <Route path="/software/login" Component={() => (<SoftwareLogin onLoggedIn={() => { setAsLoggedIn() }} />)} />
          <Route path="/buy-product" Component={ProductSelector} />
          <Route path="/buy-service" Component={BuyService} />
          <Route path="/get-company-detail" Component={GetCompanyDetailInContractRequest} />
          <Route path="/buy/product/summary" Component={ShowBuyProductSummary} />
          <Route path="/ipg/select" Component={SelectIpg} />
          <Route path="/my-contracts/list" Component={ShowMyContracts} />
          <Route path="/my-services/list" Component={ShowMyBuyServices} />
          <Route path="/my-wallet/get" Component={ShowMyWallet} />
          <Route path="/my-wallet/transaction/list" Component={ShowMyWalletTransactions} />
          <Route path="/payment/zarinpal/verify" Component={ZarinpalVerifyPayment} />
          <Route path="/admin/contract/list" Component={ContractList} />
          <Route path="/admin/ipg-transactions/list" Component={IpgTransactionList} />
          <Route path="/admin/buy-service/list" Component={BuyServiceList} />
          <Route path="/admin/client/list" Component={UserList} />
          <Route path="/admin/discount-token/list" Component={DiscountList} />
          <Route path="/admin/product/list" Component={ProductList} />
          <Route path="/admin/service/list" Component={ServiceList} />
          <Route path="/user/change-password" Component={ChangePassword} />
          <Route path="/contract/module/promote" Component={PromoteContractMudules} />
          <Route path="/contract/paremeter/promote" Component={PromoteContractParameters} />
          <Route path="/basic/paremeter/bill-descriptions" Component={BillDescriptions} />
          <Route path="/basic/paremeter/win-accounting" Component={WinAccountingParams} />
          <Route path="/basic/paremeter/school-accounting" Component={SchoolAccountingParams} />
          <Route path="/basic/paremeter/sandoogh" Component={SandooghParams} />
          <Route path="/basic/paremeter/tax-service" Component={TaxServiceParams} />
          <Route path="/chat" Component={Chat} />
          <Route path="/download" Component={DownloadFile} />
          <Route path="/start/buy/from-other-system" Component={StartBuyFromOtherSystem} />
          <Route path="/payment/show/result" Component={ShowPaymentResult} />
          <Route path="*" Component={ProductSelector} />
        </Routes>
      </>
      </>
      :
      <> 
        <Routes>
          <Route path="/reset-password" Component={ResetPassword} />
          <Route path="/login" Component={() => (<Login onLoggedIn={() => { setAsLoggedIn() }} />)} />
          <Route path="/software/login" Component={() => (<SoftwareLogin onLoggedIn={() => { setAsLoggedIn() }} />)} />
          <Route path="/request-membership" Component={() => (<RequestMembership onMembershipped={() => { setAsLoggedIn() }} />)} />
          <Route path="/buy-product" Component={ProductSelector} />
          <Route path="/buy-service" Component={BuyService} />
          <Route path="/get-company-detail" Component={GetCompanyDetailInContractRequest} />
          <Route path="/check-user-exist" Component={() => (<CheckUserExistance onMembershipped={() => { setAsLoggedIn() }} />)} />
          <Route path="/payment/zarinpal/verify" Component={ZarinpalVerifyPayment} />
          <Route path="/download" Component={DownloadFile} />
          <Route path="/start/buy/from-other-system" Component={StartBuyFromOtherSystem} />
          <Route path="/payment/show/result" Component={ShowPaymentResult} />
          <Route path="*" Component={ProductSelector} />
        </Routes>
      </>
      }
      </Row>
    </Container>
    <Row style={{margin:"200px 0px 0px 0px", padding:"20px 0px",  backgroundColor:"rgb(192, 0, 0)", color:"#fff", minHeight:"150px", width:"100%"}}>

        <div className="container text-center" style={{padding:"5px 0px 0px 10px", boxSizing:"border-box"}}>
          <Row className="justify-content-md-center" style={{padding:"0px 0px", margin:"0px"}}>
            <Col md="3" style={{margin:"5px", fontSize:"16pt", textAlign:"right",boxSizing:"border-box", backgroundColor:"#EBE5DC", minHeight:"100px", color:"rgb(192, 0, 0)", borderRadius:"10px", padding:"20px"}}>
              <table>
                <tbody>
                  <tr>
                    <td rowSpan={2} style={{textAlign:"center", verticalAlign:"middle", width:"72px"}}>
                      <i className="pi pi-phone" style={{fontSize:"24pt"}}></i>
                    </td>
                    <td style={{fontWeight:"bold"}}>شماره های تماس</td>
                  </tr>
                  <tr>
                    <td style={{direction:"ltr", paddingTop:"10px"}}>
                      087-33741916, 087-33741914
                    </td>
                  </tr>
                </tbody>
              </table>
              
            </Col>
            <Col md="3" style={{margin:"5px", fontSize:"16pt", textAlign:"right",boxSizing:"border-box", backgroundColor:"#EBE5DC", minHeight:"100px", color:"rgb(192, 0, 0)", borderRadius:"10px", padding:"20px"}}>
              <table>
                <tbody>
                  <tr>
                    <td rowSpan={2} style={{textAlign:"center", verticalAlign:"middle", width:"72px"}}>
                      <i className="pi pi-compass" style={{fontSize:"24pt"}}></i>
                    </td>
                    <td style={{fontWeight:"bold"}}>آدرس شرکت</td>
                  </tr>
                  <tr>
                    <td style={{direction:"rtl", paddingTop:"10px"}}>
                      کردستان - سنندج-بهاران 1/17 - محوطه دانشگاه پیام نور - ساختمان پارک علم و فناوری مجتمع نو‌آوران نور
                    </td>
                  </tr>
                </tbody>
              </table>
              
            </Col>
            <Col md="3" style={{margin:"5px", fontSize:"16pt", textAlign:"right",boxSizing:"border-box", backgroundColor:"#EBE5DC", minHeight:"100px", color:"rgb(192, 0, 0)", borderRadius:"10px", padding:"20px"}}>
              <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=698693&Code=3kmo2XRoLG4DPQpsqDtnjBmYl3neCx9i'>
                <img referrerpolicy='origin' src={'https://trustseal.enamad.ir/logo.aspx?id=698693&Code=3kmo2XRoLG4DPQpsqDtnjBmYl3neCx9i'} alt='' 
                  style={{cursor:"pointer", width:"96px", height:"96px"}} code='3kmo2XRoLG4DPQpsqDtnjBmYl3neCx9i' />                  
              </a>
              
            </Col>
          </Row>
        </div>
        <div style={{color:"#FFF", marginTop:"50px", borderTop:"2px solid #000", padding:"10px 10px", textAlign:"center"}}>
          <i className="pi pi-at" style={{fontSize:"10pt"}}></i>
          &nbsp;
          کلیه حقوق مادی و معنوی سایت متعلق به شرکت سامانه پرداز وستا می باشد.
        </div>

    </Row>
    </>
  );
}

export default App;
